import React from "react";
import {t} from "../../../shared-services/translate";
import AllergenBadge from "../Badges/AllergenBadge";

const AllergensPDP = (props) => {
  const {allergens} = props;
  const imagePath = "icons/allergens";
  const tKey = "products.allergens";

  return <div
    className="nutritional-info position-relative flex flex-wrap-wrap"
    style={{
      gap: "7px"
    }}
  >
    {allergens.map(allergen => <AllergenBadge
      key={allergen}
      image={`${imagePath}/${allergen}.svg`}
      color="#999999"
      backgroundColor="transparent"
    >
      <span>{t(`${tKey}.${allergen}`)}</span>
    </AllergenBadge>)}
  </div>;
};

export default AllergensPDP;
